import React from "react";
import "../report.scss";

//impport elementos de react
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Title from "../../AdminUsers/Title/Title";
import DBA from "../../DBAReport/DBAReport";
import { GET_AXIOS } from "./../../funtionsREST";

//import imagenes
import IconInteractive from "../../../img/icon-interactive.svg";
import IconVideo from "../../../img/icon-video.svg";
import IconMen from "../../../img/icon-Men.svg";
import IconVirtual from "../../../img/icon-virtual.svg";
import IconButtonSend from "../../../img/icon-button-send.svg";
import IconMateEdu from "../../../img/icon-mateEdu.svg";

//import components and views
import LoadingPage from "../../spinner/loadingPage";
import { throws } from "assert";


export interface Props {
  graphics: Array<string>;
  capitalize: any;
}

interface IState {
  grado: string;
  grupo: string;
  area: string;
  grado2: string;
  grupo2: string;
  area2: string;
  showReportButton: boolean;
  showDiseableReportButton: boolean;
  showReport: boolean;
  grades: Array<object>;
  groups: Array<object>;
  knowledgeAreas: Array<object>;
  showNotGroup: boolean;
  showReportError: boolean;
  reports: Array<report>;
  disabledGroup: boolean;
  disabledArea: boolean;
}

interface report {
  id: number;
  resource_type_name: string;
  totals: Array<object>;
}

export default class ReportDoc extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    // No llames this.setState() aquí!
    this.state = {
      grado: "-1",
      grupo: "-1",
      area: "-1",
      grado2: "-1",
      grupo2: "-1",
      area2: "-1",
      showReport: false,
      showReportError: false,
      showNotGroup: false,
      showDiseableReportButton: false,
      showReportButton: false,
      disabledGroup: false,
      disabledArea: false,
      grades: [],
      groups: [],
      knowledgeAreas: [],
      reports: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.GenerateReport = this.GenerateReport.bind(this);
    this.handledSelectGrade = this.handledSelectGrade.bind(this);
  }

  handleInputChange(event: React.FormEvent<HTMLInputElement>) {
    const target = event.currentTarget;
    const value = target.value;
    const name = target.name;
    const me = this;
    this.setState({
      showReport: false,
      showReportButton: false,
      showDiseableReportButton: false,
      showReportError: false,
    });

    me.setState(
      (prevState) => ({
        ...prevState,
        [name]: value,
        showReportButton: true,
      }),
      () => {
        if (
          me.state.grado !== "-1" &&
          me.state.grupo !== "-1" &&
          me.state.area !== "-1"
        )
          me.setState({ showDiseableReportButton: true });
      }
    );

    if (name === "grado") {
      console.log(value);
      this.getAreas(value);
      let _grade = value;
      GET_AXIOS(`getByheadquarterGrade/-1/${_grade}`)
        .then((res) => {
          console.log(res, res.data[0] !== 0, res.data[0] === 0);
          this.setState((prevState) => ({
            ...prevState,
            grupo: "-1",
            groups: [],
          }));
          let _data: Array<object> = res.data
            ? res.data.map((el: any) => ({ id: el, name: el }))
            : [];
          _data = _data.filter((da: any) => da.name);
          this.setState({ groups: _data, showNotGroup: false });
        })
        .catch((e) => {
          this.setState({ showNotGroup: true });
        });
    }
  }

  GenerateReport(event: React.FormEvent<HTMLFormElement>) {
    console.log("hola");
    const jsonToReport = {
      grade: this.state.grado,
      group: this.state.grupo,
      knowledge_area: this.state.area,
    };

    event.preventDefault();
    if (
      this.state.grado !== "-1" &&
      this.state.grupo !== "-1" &&
      this.state.area !== "-1"
    ) {
      GET_AXIOS(
        `stats/byGroupAreaGrade/${jsonToReport.grade}/-1/${jsonToReport.group}/${jsonToReport.knowledge_area}`
      )
        .then((res) => {
          console.log(res.data);
          if (res.data !== undefined && res.data !== false) {
            this.setState({ reports: res.data }, () => {
              this.setState({
                showReport: true,
                showReportError: false,
                grado2: jsonToReport.grade,
                grupo2: jsonToReport.group,
                area2: jsonToReport.knowledge_area,
              });
            });
          } else {
            this.setState({
              showReport: false,
              showReportError: true,
            });
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({
            showReport: false,
            showReportError: true,
          });
        });
    }
  }

  generatePDF() {
    const { grado, grupo, area } = this.state;

    window.open(
      `${process.env.REACT_APP_API_ENDPOINT}stats/generateReport?grade=${grado}&group=${grupo}&knowledge_area=${area}`,
      "_blank"
    );
  }

  getValueFromArray(arr: Array<object>, idToSearch: string, toReturn: any) {
    const _ele: any = arr.find((el: any) => el.id === idToSearch);
    console.log(_ele, arr, idToSearch, toReturn);
    if (_ele) {
      return _ele[toReturn];
    }
  }

  componentDidMount() {
    GET_AXIOS("users/grades")
      .then((res) => {
        const _data: Array<object> = this.props.capitalize(
          res.data,
          "grade_name"
        );
        this.setState({ grades: _data });
      })
      .catch((e) => {
        console.log(e);
      });


  }

  handledSelectGrade(event: React.FormEvent<HTMLInputElement>) {
    const target = event.currentTarget;
    const value = target.value;

    this.setState({
      showReport: false,
      showReportButton: false,
      showDiseableReportButton: false,
      showReportError: false,
      grado: value,
    });

    if (value === "-1") {
      this.setState({ disabledArea: false, disabledGroup: false });
      this.setState((prevState) => ({
        ...prevState,
        area: "-1",
        knowledgeAreas: [],
        grupo: "-1",
        groups: [],
      }));
    }

    if (value !== "-1") {
      GET_AXIOS(`getByheadquarterGrade/-1/${value}`)
        .then((res) => {
          console.log(res, res.data[0] !== 0, res.data[0] === 0);
          this.setState((prevState) => ({
            ...prevState,
            grupo: "-1",
            groups: [],
          }));
          let _data: Array<object> = res.data
            ? res.data.map((el: any) => ({ id: el, name: el }))
            : [];
          _data = _data.filter((da: any) => da.name);
          this.setState({ groups: _data, showNotGroup: false, disabledGroup: true });
        })
        .catch((e) => {
          this.setState({ showNotGroup: true });
        });

      this.getAreas(value);
    }
  }

  getAreas(grades: any) {
    console.log(grades);
    GET_AXIOS(`users/knowledgeAreas/${grades}`)
      .then((res) => {
        this.setState((prevState) => ({
          ...prevState,
          area: "-1",
          knowledgeAreas: [],
        }));
        console.log(res.data);
        const _data: Array<object> = this.props.capitalize(
          res.data,
          "knowledge_area_name"
        );
        this.setState({ knowledgeAreas: _data, disabledArea: true });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    let { grades, groups, knowledgeAreas, disabledArea, disabledGroup } = this.state;

    return (
      <>
        <Row className="justify-content-center align-self-center text-center">
          <Row className="w-100  h-100 pt-5">
            <Col>
              <h2 className="title-report">ESTIMADO(A) DOCENTE,</h2>
            </Col>
          </Row>
          <Row className="justify-content-center align-self-center text-center w-100  h-100">
            <Col
              className="justify-content-center align-self-center text-center p-0"
              md={12}
            >
              <p>
                Para visualizar el estado y progreso de sus estudiantes, en
                relación con el acceso y uso de los contenidos y/o recursos,
                seleccione el grado, el grupo y el aréa que desea consultar.
              </p>
            </Col>
          </Row>
          <Row className="w-100 mb-4">
            <Col className="d-flex justify-content-center">
              <div className="separator" />
            </Col>
          </Row>
          <Form className="container-fluid form-report-Infor" onSubmit={this.GenerateReport}>
            <Row className="justify-content-center align-self-center text-center">
              <Col
                className="justify-content-center align-self-center text-center"
                md={6}
              >
                <Form.Control
                  className="af-reportselect w-100 m-1"
                  custom
                  name="grado"
                  value={this.state.grado}
                  defaultValue={"-1"}
                  onChange={this.handledSelectGrade}
                  as="select"
                  required
                >
                  <option value="-1">Escoge el grado</option>
                  {grades.map((grade: any) => (
                    <option value={grade.id}>
                      {grade.grade_name.toUpperCase()}
                    </option>
                  ))}
                </Form.Control>
              </Col>
              <Col
                className="justify-content-center align-self-center text-center"
                md={6}
              >
                <Form.Control
                  className="af-reportselect w-100 m-1"
                  name="grupo"
                  value={this.state.grupo}
                  defaultValue={"-1"}
                  onChange={this.handleInputChange}
                  as="select"
                  required
                  disabled={disabledGroup === false}

                >
                  <option value="-1">Escoge el grupo</option>
                  {groups.map((gr: any) => (
                    <option value={gr.id}>{gr.id}</option>
                  ))}
                </Form.Control>
              </Col>
              <Col
                className="justify-content-center align-self-center text-center"
                md={6}
              >
                <Form.Control
                  className="af-reportselect w-100 m-1"
                  name="area"
                  value={this.state.area}
                  defaultValue={"-1"}
                  onChange={this.handleInputChange}
                  as="select"
                  required
                  disabled={disabledArea === false}
                >
                  <option value="-1">Escoge el área</option>
                  {knowledgeAreas.map((ka: any) => (
                    <option value={ka.id}>
                      {ka.knowledge_area_name.toUpperCase()}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="d-flex align-items-center justify-content-center generate-report">
                {this.state.showReportButton &&
                  (this.state.showDiseableReportButton === true ? (
                    <Button
                      variant="primary"
                      type="submit"
                      className="generate-report-button d-flex justify-content-center align-items-center"
                      block
                    >
                      Generar Reporte
                      <img
                        src={IconButtonSend}
                        alt=""
                        className="ml-3 icon-generate-report"
                      />
                    </Button>
                  ) : (
                      <Button
                        variant="primary"
                        type="submit"
                        className="generate-report-button d-flex justify-content-center align-items-center"
                        block
                        disabled
                      >
                        Generar Reporte
                        <img
                          src={IconButtonSend}
                          alt=""
                          className="ml-3 icon-generate-report"
                        />
                      </Button>
                    ))}
              </Col>
            </Row>
          </Form>
          {this.state.showNotGroup && (
            <Container>
              <Row>
                <Col className="" md={12}>
                  <h4>No hay grupos disponibles en este momento.</h4>
                </Col>
              </Row>
            </Container>
          )}
          {this.state.showReport && (
            <LoadingPage>
              <Container fluid>
                <Row>
                  <Col>
                    <Title>Informe</Title>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>
                      En el siguiente informe encontrarás el estado de avance en
                      relación con el acceso y uso de los contenidos y recursos,
                      según el ciclo, el grupo y el área consultados.
                  </p>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <p className="text-center selected-type w-100 p-2">
                      Grado:{" "}
                      {this.getValueFromArray(
                        this.state.grades,
                        this.state.grado2,
                        "grade_name"
                      )}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p className="text-center selected-type w-100 p-2">
                      Grupo:{" "}
                      {this.getValueFromArray(
                        this.state.groups,
                        this.state.grupo2,
                        "name"
                      )}
                    </p>
                  </Col>
                  <Col md={4}>
                    <p className="text-center selected-type w-100 p-2">
                      Área:{" "}
                      {this.getValueFromArray(
                        this.state.knowledgeAreas,
                        this.state.area2,
                        "knowledge_area_name"
                      )}
                    </p>
                  </Col>
                </Row>
                {this.state.reports.filter((data: any) => data.id === 1)[0] &&
                  <Row className="mt-4 mb-2">
                    <Col className="d-flex subtitle-report">
                      <img src={IconVideo} alt="" className="icon-report" />
                      <h3>Videos:</h3>
                    </Col>
                  </Row>
                }
                {this.state.reports.filter((data: any) => data.id === 1)[0]
                  ? this.state.reports
                    .filter((data: any) => data.id === 1)[0]
                    .totals.map((value: any) => {
                      return (
                        <DBA
                          atribute="videos"
                          dba={value.dba}
                          total={value.total}
                          student={value.users}
                          type={1}
                        ></DBA>
                      );
                    })
                  : ""}
                {this.state.reports.filter((data: any) => data.id === 2)[0] &&
                  <Row className="mt-4 mb-2">
                    <Col className="d-flex subtitle-report">
                      <img src={IconInteractive} alt="" className="icon-report" />
                      <h3>Actividades interactivas:</h3>
                    </Col>
                  </Row>
                }
                {this.state.reports.filter((data: any) => data.id === 2)[0]
                  ? this.state.reports
                    .filter((data: any) => data.id === 2)[0]
                    .totals.map((value: any) => {
                      return (
                        <DBA
                          atribute="actividades"
                          dba={value.dba}
                          total={value.total}
                          student={value.users}
                          type={1}
                        ></DBA>
                      );
                    })
                  : ""}
                {this.state.reports.filter((data: any) => data.id === 3)[0] &&
                  <Row className="mt-4 mb-2">
                    <Col className="d-flex subtitle-report">
                      <img src={IconMen} alt="" className="icon-report" />
                      <h3>Recursos MEN:</h3>
                    </Col>
                  </Row>
                }
                {this.state.reports.filter((data: any) => data.id === 3)[0]
                  ? this.state.reports
                    .filter((data: any) => data.id === 3)[0]
                    .totals.map((value: any) => {
                      return (
                        <DBA
                          atribute="recursos"
                          dba={value.dba}
                          total={value.total}
                          student={value.users}
                          type={1}
                        ></DBA>
                      );
                    })
                  : ""}
                {this.state.reports.filter((data: any) => data.id === 4)[0] &&
                  <Row className="mt-4 mb-2">
                    <Col className="d-flex subtitle-report">
                      <img src={IconVirtual} alt="" className="icon-report" />
                      <h3>Aula virtual:</h3>
                    </Col>
                  </Row>
                }
                {this.state.reports.filter((data: any) => data.id === 4)[0]
                  ? this.state.reports
                    .filter((data: any) => data.id === 4)[0]
                    .totals.map((value: any) => {
                      return (
                        <DBA
                          atribute="contenidos"
                          dba={value.dba}
                          total={value.total}
                          student={value.users}
                          type={1}
                        ></DBA>
                      );
                    })
                  : ""}
				  {this.state.reports.filter((data: any) => data.id === 6)[0] &&
					<Row className="mt-4 mb-2">
					  <Col className="d-flex subtitle-report">
						<img src={IconVirtual} alt="" className="icon-report" />
						<h3>Modelos Test:</h3>
					  </Col>
					</Row>
				  }
				  {this.state.reports.filter((data: any) => data.id === 6)[0]
					? this.state.reports
					  .filter((data: any) => data.id === 6)[0]
					  .totals.map((value: any) => {
						return (
						  <DBA
							atribute="contenidos"
							dba={value.dba}
							total={value.total}
							student={value.users}
							type={1}
						  ></DBA>
						);
					  })
					: ""}

                {this.state.reports.filter((data: any) => data.id === 5)[0] &&
                  <Row className="mt-4 mb-2">
                    <Col className="d-flex subtitle-report">
                      <img src={IconMateEdu} alt="" className="icon-report" />
                      <h3>Materiales Educativos:</h3>
                    </Col>
                  </Row>
                }
                {this.state.reports.filter((data: any) => data.id === 5)[0]
                  ? this.state.reports
                    .filter((data: any) => data.id === 5)[0]
                    .totals.map((value: any) => {
                      return (
                        <DBA
                          atribute="contenidos"
                          dba={value.dba}
                          total={value.total}
                          student={value.users}
                          type={1}
                        ></DBA>
                      );
                    })
                  : ""}

                <Row className="my-4">
                  <Col md={12}>
                    <Button
                      variant="primary"
                      type="button"
                      className="Butoon-generate-report"
                      block
                      onClick={() => this.generatePDF()}
                    >
                      Para generar el reporte detallado por estudiante haz clic
                      aquí.
                  </Button>
                  </Col>
                </Row>
              </Container>
            </LoadingPage>
          )}
          {this.state.showReportError && (
            <Container className="mt-4" fluid>
              <Row>
                <Col className="" md={12}>
                  <h4>No hay reporte disponibles en este momento.</h4>
                </Col>
              </Row>
            </Container>

          )}
        </Row>
      </>
    );
  }
}
